class Quote {
  constructor (data) {
    this.id = data ? data.id : ''
    this.company = data ? data.company : ''
    this.name = data ? data.name : ''
    this.email = data ? data.email : ''
    this.phone = data ? data.phone : ''
    this.pickup_date = data ? data.pickup_date : ''
    this.ship_from_zip = data ? data.ship_from_zip : ''
    this.ship_from_location_type = data ? data.ship_from_location_type : ''
    this.ship_to_zip = data ? data.ship_to_zip : ''
    this.ship_to_location_type = data ? data.ship_to_location_type : ''
    this.non_commercial_delivery = data ? data.non_commercial_delivery : ''
    this.extra_delivery_service = data ? data.extra_delivery_service : ''
    this.no_of_items = data ? data.no_of_items : ''
    this.packaging = data ? data.packaging : ''
    this.weight = data ? data.weight : ''
    this.length = data ? data.length : ''
    this.width = data ? data.width : ''
    this.height = data ? data.height : ''
    this.freight_class = data ? data.freight_class : ''
    this.is_hazardous = data ? data.is_hazardous : ''
    this.created_at = data ? data.created_at : ''
  }
}

export default Quote



// WEBPACK FOOTER //
// ./src/models/Quote.js